import script from "./VBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./VBtn.vue?vue&type=script&lang=ts&setup=true"

import "./VBtn.vue?vue&type=style&index=0&id=7d0a49ae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0a49ae"]])

export default __exports__